export default __webpack_public_path__ + "static/media/pen-only-disabled.5f109e90.svg";